/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { setIsLoading, setManipulableSettings, updateCenterGraphData } from "../store/slice/centerGraphSlice";
import { createMatrix, createRandomValuesArray } from "../utils/ArrayUtils";
import { getFormattedLabels } from "../utils/TimeUtils";

export const updateCenterGraph = (dispatch, retriveredData) => {
	retriveredData = {
		...retriveredData,
		xLabels: retriveredData.xLabels.map((time) => {
			return time > 23 ? getFormattedLabels(time) :
				time === 0 ? "00:00" : time < 10 ? "0" + time + ":00" : time + ":00"
		})
	}

	const centerGraph = {
		data: {
			...retriveredData
		}
	}

	if (retriveredData.values.length === 0) {
		let placeholderData = getPlaceholderData(centerGraph)
		dispatch(updateCenterGraphData(placeholderData.data))
	} else {
		retriveredData.colors = ["#71d9f3", "#c7d540", "#ffadef", "#41e287", "#ffdf41"]
		dispatch(updateCenterGraphData(retriveredData))
	}

	dispatch(setIsLoading(false))
	dispatch(setManipulableSettings({
		VR: ['rotation', 'zoom', 'explore'],
		desktop: ['rotation'],
	}))
}

export const getPlaceholderData = (placeholderData) => {
	Object.assign(placeholderData.data, {
		values: createMatrix(createRandomValuesArray(13, 10), 3),
		xLabels: [],
		zLabels: [],
		colors: ["#363636", "#474747", "#5c5c5c"],
	});

	return placeholderData
}